import type { ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import { echoTheme } from './theme';

interface EchoProviderProps {
  children: ReactNode;
}

const EchoProvider = ({ children }: EchoProviderProps) => (
  <ConfigProvider theme={echoTheme}>{children}</ConfigProvider>
);

export { EchoProvider };
